var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4766 45.6008C35.903 45.6008 45.9766 35.5272 45.9766 23.1008C45.9766 10.6744 35.903 0.60083 23.4766 0.60083C11.0502 0.60083 0.976562 10.6744 0.976562 23.1008C0.976562 35.5272 11.0502 45.6008 23.4766 45.6008Z",
    fill: "#2350F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4443 23.5405C22.4443 23.8057 22.5497 24.0601 22.7372 24.2476C22.9248 24.4352 23.1791 24.5405 23.4443 24.5405C23.7096 24.5405 23.9639 24.4352 24.1514 24.2476C24.339 24.0601 24.4443 23.8057 24.4443 23.5405C24.4443 23.2753 24.339 23.021 24.1514 22.8334C23.9639 22.6459 23.7096 22.5405 23.4443 22.5405C23.1791 22.5405 22.9248 22.6459 22.7372 22.8334C22.5497 23.021 22.4443 23.2753 22.4443 23.5405Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4443 23.5405C18.4443 24.8666 18.9711 26.1384 19.9088 27.0761C20.8465 28.0137 22.1183 28.5405 23.4443 28.5405C24.7704 28.5405 26.0422 28.0137 26.9799 27.0761C27.9176 26.1384 28.4443 24.8666 28.4443 23.5405C28.4443 22.2144 27.9176 20.9427 26.9799 20.005C26.0422 19.0673 24.7704 18.5405 23.4443 18.5405C22.1183 18.5405 20.8465 19.0673 19.9088 20.005C18.9711 20.9427 18.4443 22.2144 18.4443 23.5405Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4443 23.5405C14.4443 24.7224 14.6771 25.8927 15.1294 26.9847C15.5817 28.0766 16.2446 29.0688 17.0804 29.9045C17.9161 30.7402 18.9083 31.4032 20.0002 31.8554C21.0921 32.3077 22.2624 32.5405 23.4443 32.5405C24.6262 32.5405 25.7966 32.3077 26.8885 31.8554C27.9804 31.4032 28.9726 30.7402 29.8083 29.9045C30.644 29.0688 31.307 28.0766 31.7593 26.9847C32.2115 25.8927 32.4443 24.7224 32.4443 23.5405C32.4443 22.3586 32.2115 21.1883 31.7593 20.0964C31.307 19.0044 30.644 18.0123 29.8083 17.1766C28.9726 16.3408 27.9804 15.6779 26.8885 15.2256C25.7966 14.7733 24.6262 14.5405 23.4443 14.5405C22.2624 14.5405 21.0921 14.7733 20.0002 15.2256C18.9083 15.6779 17.9161 16.3408 17.0804 17.1766C16.2446 18.0123 15.5817 19.0044 15.1294 20.0964C14.6771 21.1883 14.4443 22.3586 14.4443 23.5405Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTarget);
export default __webpack_public_path__ + "static/media/target.c821d5811d44a2c363ca88a6e301f1d5.svg";
export { ForwardRef as ReactComponent };